import { render, staticRenderFns } from "./DirectSale.vue?vue&type=template&id=0dd095e2&"
import script from "./DirectSale.vue?vue&type=script&lang=js&"
export * from "./DirectSale.vue?vue&type=script&lang=js&"
import style0 from "./DirectSale.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports